import { IconButton } from "../Buttons";

const QuestionMarkSvg = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M12.0373 18.9743C12.332 18.9743 12.5807 18.8726 12.7833 18.669C12.986 18.4654 13.0873 18.2163 13.0873 17.9217C13.0873 17.6268 12.9856 17.3781 12.782 17.1757C12.5784 16.973 12.3292 16.8717 12.0343 16.8717C11.7397 16.8717 11.491 16.9734 11.2883 17.177C11.0859 17.3806 10.9847 17.6298 10.9847 17.9247C10.9847 18.2193 11.0864 18.468 11.29 18.6707C11.4936 18.8731 11.7427 18.9743 12.0373 18.9743ZM11.3487 14.559H12.636C12.6702 13.9794 12.7791 13.5084 12.9627 13.146C13.1464 12.7838 13.5247 12.3214 14.0973 11.759C14.6922 11.1641 15.135 10.6312 15.4257 10.1603C15.7163 9.68945 15.8617 9.14433 15.8617 8.525C15.8617 7.47411 15.4924 6.63667 14.754 6.01267C14.0156 5.38889 13.142 5.077 12.1333 5.077C11.1744 5.077 10.3603 5.33767 9.691 5.859C9.02189 6.38033 8.53178 6.97944 8.22067 7.65633L9.446 8.164C9.65978 7.67867 9.96533 7.24967 10.3627 6.877C10.7602 6.50433 11.3333 6.318 12.082 6.318C12.9469 6.318 13.5786 6.55511 13.977 7.02933C14.3752 7.50378 14.5743 8.02567 14.5743 8.595C14.5743 9.05655 14.4496 9.46889 14.2 9.832C13.9504 10.1953 13.6257 10.5608 13.2257 10.9283C12.453 11.641 11.947 12.2452 11.7077 12.741C11.4683 13.2368 11.3487 13.8428 11.3487 14.559ZM12.0043 24C10.345 24 8.78489 23.6851 7.324 23.0553C5.86333 22.4256 4.59267 21.5709 3.512 20.4913C2.43133 19.4118 1.57589 18.1422 0.945667 16.6827C0.315222 15.2233 0 13.6639 0 12.0043C0 10.345 0.314889 8.78489 0.944667 7.324C1.57444 5.86333 2.42911 4.59267 3.50867 3.512C4.58822 2.43133 5.85778 1.57589 7.31733 0.945667C8.77667 0.315222 10.3361 0 11.9957 0C13.655 0 15.2151 0.31489 16.676 0.944668C18.1367 1.57445 19.4073 2.42911 20.488 3.50867C21.5687 4.58822 22.4241 5.85778 23.0543 7.31733C23.6848 8.77667 24 10.3361 24 11.9957C24 13.655 23.6851 15.2151 23.0553 16.676C22.4256 18.1367 21.5709 19.4073 20.4913 20.488C19.4118 21.5687 18.1422 22.4241 16.6827 23.0543C15.2233 23.6848 13.6639 24 12.0043 24ZM12 22.6667C14.9778 22.6667 17.5 21.6333 19.5667 19.5667C21.6333 17.5 22.6667 14.9778 22.6667 12C22.6667 9.02222 21.6333 6.5 19.5667 4.43333C17.5 2.36667 14.9778 1.33333 12 1.33333C9.02222 1.33333 6.5 2.36667 4.43333 4.43333C2.36667 6.5 1.33333 9.02222 1.33333 12C1.33333 14.9778 2.36667 17.5 4.43333 19.5667C6.5 21.6333 9.02222 22.6667 12 22.6667Z"
      fill="currentColor"
    />
  </svg>
);

/**
 * Same look as the interactive button, but not a control — absorbs pointer events.
 */
const QuestionIconReadOnly = () => (
  <div
    className="question-icon-decorative"
    role="presentation"
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
    }}
    onMouseDown={(e) => e.stopPropagation()}
    onPointerDown={(e) => e.stopPropagation()}
  >
    <span
      className="question-icon-decorative__inner"
      aria-hidden="true"
      style={{
        marginTop: "10px",
        color: "#0D6EFD",
        display: "inline-flex",
        alignItems: "center",
      }}
    >
      <QuestionMarkSvg />
    </span>
  </div>
);

/**
 * QuestionIconButton — question mark for help/info.
 * @param {boolean} readOnly — when true, same appearance but not clickable (Directory "?" dummy).
 */
const QuestionIconButton = ({ onClick, readOnly = false }) => {
  if (readOnly) {
    return <QuestionIconReadOnly />;
  }

  return (
    <IconButton
      icon={<QuestionMarkSvg />}
      className="icon-button"
      style={{
        marginTop: "10px",
        color: "#0D6EFD",
      }}
      ariaLabel="Help information"
      onClick={onClick}
    />
  );
};

export default QuestionIconButton;
